import { MediaObject } from 'drywall';
import { css } from 'styled-components';
import { ie11Mixin } from '../ie11Mixin';
import { spaceMixin } from '../spaceMixin';
import { spacingMixin } from '../spacingMixin';
var ALIGN = {
  top: 'flex-start',
  start: 'flex-start',
  center: 'center',
  bottom: 'flex-end',
  end: 'flex-end'
};
var reverseCSS = function reverseCSS(props) {
  var reverse = props.reverse,
    gutter = props.gutter;
  if (!reverse) {
    return '';
  }
  return css(["", "{order:2;margin-right:0;margin-left:", ";}"], MediaObject.Media, spaceMixin(gutter));
};
var ieCSS = /*#__PURE__*/css(["", ",", "{max-width:100%;min-width:1px;}"], MediaObject.Media, MediaObject.Body);

/** @class MediaObjectMixin */
/** @method */
export var MediaObjectMixin = function MediaObjectMixin(props) {
  var align = props.align,
    direction = props.direction,
    gutter = props.gutter;
  return css(["display:flex;flex-direction:", ";align-items:", ";", "{margin-", ":", ";}", "{flex-grow:1;}", " ", " ", ""], direction, ALIGN[align], MediaObject.Media, direction === 'row' ? 'right' : 'bottom', spaceMixin(gutter)(props), MediaObject.Body, ie11Mixin(ieCSS), reverseCSS(props), spacingMixin(props));
};